import { lazy } from 'react'; 
import { MOD_USER_PROFILE } from '@/configs/ModulesConfig'; 

const SystemUserProfile = lazy(() => import('./SystemUserProfile')); 

const route = [ 
    {
        path: MOD_USER_PROFILE.base_path,
        element: <SystemUserProfile />,
        auth: MOD_USER_PROFILE.system_user_auth
    }
];



export default route;